import {observable, action, runInAction} from 'mobx'
import {PAGE_SIZE_DEFAULT} from '../constants/appConstant'
import emailTemplateAPI from '../apis/emailTemplateAPI'
import alertMessage from '../utils/alertMessage'

export default class EmailTemplateStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable pageSize = PAGE_SIZE_DEFAULT
  @observable pageNo = 1
  @observable currIndex = 0
  @observable itemCount = 0
  @observable pageSizeLog = PAGE_SIZE_DEFAULT
  @observable pageNoLog = 1
  @observable currIndexLog = 0
  @observable inBoundNameList = []

  //Status 下拉列表
  @observable statusList = []
  @action
  async onGetStatus(params) {
    this.statusList = []
    try {
      const response = await emailTemplateAPI.getStatus(params)
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          this.statusList = data
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }
  //获取预发送效果检测列表
  @observable templateStatusList = []
  @action
  async onGetTemplateStatus(params) {
    try {
      const response = await emailTemplateAPI.getTemplateStatus(params)
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          this.templateStatusList = this.templateStatusList.concat({id: params?.id,data})
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }
  /*SearchResult start*/
  @observable searchItem = {
    'marketGroupId': '',
    'page': this.pageNo,
    'size': this.pageSize,
  }
  @observable jobList = []

  @action
  async onSearchJobAction(params) {
    this.isFetching = true
    this.jobList = []
    this.templateStatusList = []
    this.pageNo = params.page
    this.pageSize = params.size
    this.itemCount = 0
    try {
      const response = await emailTemplateAPI.searchAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.jobList = response.data.data?.templateList || []
          this.itemCount = response.data.data?.templateList?.length
          this.searchItem = params
          this.jobList.map(a=>{
            return this.onGetTemplateStatus({
              id: a?.id,
              marketGroupId: params.marketGroupId
            })
          })
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @observable groupList = []
  @action
  async onGetGroup(params) {
    this.groupList = []
    try {
      const response = await emailTemplateAPI.getGroup(params)
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          this.groupList = data
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }

  @action
  onChangeJob(value) {
    this.jobList = value
    this.itemCount = 0
  }

  /*SearchResult end*/

  /*add*/
  @action
  async onAddJobAction(params, title) {
    this.isFetching = true
    try {
      const response = await emailTemplateAPI.addAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data?.code === 0) {
          alertMessage.success(title === 'edit' ? '编辑成功！' : '添加成功！')
          this.onSearchJobAction(this.searchItem)
        } else {
          alertMessage.error(title === 'edit' ? '编辑失败！' + response.data?.messageEn : '添加失败！' + response.data?.messageEn)
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
  /*edit*/
  @action
  async onEditJobAction(params, title) {
    this.isFetching = true
    try {
      const response = await emailTemplateAPI.editAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data?.code === 0) {
          alertMessage.success(title === 'edit' ? '编辑成功！' : '添加成功！')
          this.onSearchJobAction(this.searchItem)
        } else {
          alertMessage.error(title === 'edit' ? '编辑失败！' + response.data?.messageEn : '添加失败！' + response.data?.messageEn)
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*get edit*/
  @observable detailsObj = null
  @action
  async onGetJobAction(params) {
    this.isFetching = true
    try {
      const response = await emailTemplateAPI.getAction(params)
      runInAction(() => {
        this.isFetching = false
        const {data} = response.data
        if (response.data.code === 0) {
          this.detailsObj = data?.templateList[0] || null
        }
      })
      return response.data.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*delete*/
  @action
  async onDeleteJobAction(params) {
    this.isFetching = true
    try {
      const response = await emailTemplateAPI.deleteAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('删除成功！')
          this.onSearchJobAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('删除失败！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    this.onSearchJobAction({
      ...this.searchItem,
      'page': pageNo,
      'size': pageSize,
    })
  }
  /*地址解析为htmlStr*/
  @observable toTempObj = null
  @observable isFetchingTo = false
  @action
  async onHtmlToTemplateAction(params) {
    this.isFetchingTo = true
    try {
      const response = await emailTemplateAPI.htmlToTemplateAction(params)
      runInAction(() => {
        this.isFetchingTo = false
        if (response.data.code === 0) {
          this.toTempObj = response.data.data
          // alertMessage.success('Analysis Success！')
        } else {
          alertMessage.error('解析失败！' + response.data.messageEn + '')
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetchingTo = false
      })
    }
  }
}
